<template>
  <nav-bar title="督办信息" />
  <Content :bottom="0" @content-scroll="handleContentScroll">
    <Loading v-if="showLoading" :isLoading="isLoading" @reload="getList" />
    <ul class="list">
      <li
        class="list-item"
        v-for="item in list"
        :key="item.id"
        @click="handleItemClick(item)"
      >
        <p>{{ item.title }}</p>
        <div class="desc">
          <span>发送人：{{ item.msgFromName }}</span>
          <span>状态：{{ item.statusName }}</span>
        </div>
      </li>
    </ul>
    <loading-more :finished="finished" :showLoadingMore="showLoadingMore" :loadingFail="loadingFail" :list="list" @reload="reload()" />
  </Content>
  <Popup title="督办信息" ref="popup">
    <div class="notice-content">
      <p>{{ content }}</p>
      <p><van-button
      v-if="currStatus === '1'"
        style="margin: 0 auto"
        type="primary"
        size="small"
        @click="handleReadClick"
        >已阅</van-button
      >
      </p>
    </div>
  </Popup>
</template>

<script>
import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import { getMessListByUserId, readMessById } from '@/api/user'
import { useLoadingMore } from '@/hooks/useLoadingMore'
import { useGetData } from '@/hooks/useGetData'
export default {
  name: 'SupervisionInformation',
  setup(props) {
    const store = useStore()
    const username = computed(() => store.state.userInfo.username)
    const userId = computed(() => store.state.userInfo.id)
    const companyId = computed(() => store.state.roleInfo.companyId)
    const roleId = computed(() => store.state.roleInfo.roleId)
    const data = useLoadingMore(getMessListByUserId)
    const {
      getList,
      list,
      finished,
      loadingFail,
      pageParams
    } = data

    // 初始化list
    const init = () => {
      list.value = []
      pageParams.page = 1
      pageParams.userId = userId.value
      pageParams.username = username.value
      pageParams.companyId = companyId.value
      pageParams.roleId = roleId.value
      finished.value = false
      loadingFail.value = false
      getList()
    }
    init()
    const popup = ref(null)
    const content = ref('')
    const currId = ref('')
    const currStatus = ref('')
    const handleItemClick = ({ maintext, id, status }) => {
      content.value = maintext
      currId.value = id
      currStatus.value = status
      popup.value.showPopup()
    }
    const handleReadClick = () => {
      useGetData(readMessById, data => {
        popup.value.hidePopup()
        init()
      })(currId.value)
    }
    return {
      ...data,
      getList,
      popup,
      content,
      handleItemClick,
      handleReadClick,
      currStatus
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  padding: 0 16px;
  font-size: 14px;
  .list-item {
    background-color: #fff;
    padding: 10px 16px;
    margin-top: 16px;
    border-radius: 5px;
    p {
      margin: 0;
      line-height: 28px;
      font-weight: 600;
    }
    .desc {
      color: #666;
      font-size: 12px;
      span {
        margin-right: 10px;
      }
    }
  }
}
.notice-content {
  font-size: 14px;
  line-height: 26px;
  color: #333;
  padding: 16px;
}
</style>
